import JobOfferBenefitsTerms from './JobOfferBenefitsTerms'
export default JobOfferBenefitsTerms
